// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRecycle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.427 5.976a6.977 6.977 0 0 1 2.532 2.486.376.376 0 1 1-.644.384 6.195 6.195 0 0 0-11.455 2.3l-.093.686 1.372-1.203a.374.374 0 0 1 .412-.054.365.365 0 0 1 .116.091.37.37 0 0 1-.038.528L5.657 12.91a.387.387 0 0 1-.531-.035L3.412 10.9a.373.373 0 0 1-.09-.274.363.363 0 0 1 .127-.254.374.374 0 0 1 .528.035l1.05 1.207.078-.563A6.967 6.967 0 0 1 12 5.057a6.977 6.977 0 0 1 3.427.92zM20.592 13.142a.377.377 0 0 1-.044.528.388.388 0 0 1-.532-.045l-1.076-1.282-.082.576a6.943 6.943 0 0 1-12.85 2.63.374.374 0 0 1 .318-.566.453.453 0 0 1 .096 0 .373.373 0 0 1 .23.171 6.192 6.192 0 0 0 11.462-2.256l.096-.685-1.351 1.134a.394.394 0 0 1-.275.09.388.388 0 0 1-.324-.262.373.373 0 0 1 .115-.4l2.003-1.684a.401.401 0 0 1 .274-.089c.099.01.19.058.254.134l1.686 2.002z"
    />
  </svg>
);
export default SvgRecycle;
